package de.ohhhmhhh.backend.models.model.invoice

import kotlinx.serialization.Serializable

@Serializable
enum class InvoiceStateEntity {
    PENDING, SUCCESSFUL, FAILED
}